import { memo } from 'react';
import cn from 'classnames';
import CloseIcon from '@stripcash/ui-kit/icons/close.svg';
import ButtonIcon, {
  ButtonIconStyle,
} from '@stripcash/ui-kit/components/ButtonIcon';

import { Translate } from 'common/i18n/types';

import style from './style.module.css';

type PropsType = {
  onClose: () => void;
  t: Translate;
};

const ModalThank = memo(({ onClose, t }: PropsType) => (
  <div className={cn(style.contactUsModal)}>
    <h2 className={cn(style.contactUsModalHeader)}>
      {t('contactUs.suссessSubtitle')}
    </h2>
    <p className={cn(style.contactUsModalDescription)}>
      {t('contactUs.successText')}
    </p>
    <div className={cn(style.contactUsCloseBtn)}>
      <ButtonIcon style={ButtonIconStyle.SmallColored} onClick={onClose}>
        <CloseIcon size={12} />
      </ButtonIcon>
    </div>
  </div>
));

export default ModalThank;
